// Multi-step Form JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Check if formConfig exists (provided by Liquid template)
  if (typeof window.formConfig === 'undefined') {
    console.error('Form configuration not found!');
    return;
  }

  const { countryPricing, sectionDefaultLang } = window.formConfig;
  
  // Debug the share button
  const shareButton = document.getElementById("shareButton");
  if (shareButton) {
    console.log("Share button found:", shareButton);
    console.log("data-share-title:", shareButton.getAttribute('data-share-title'));
    console.log("data-share-text:", shareButton.getAttribute('data-share-text'));
  } else {
    console.error("Share button not found!");
  }

  // Share button functionality
  if (shareButton) {
    shareButton.addEventListener("click", async () => {
      const country = document.getElementById('country-select').value;
      const trackerNumber = document.getElementById('tracker-select').value;
      
      const hash = btoa(`${country}|${trackerNumber}`).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
      const shareUrl = `https://www.pitcherogps.com/pages/new-view-price?h=${hash}`;
      
      const refreshedShareButton = document.getElementById("shareButton");
      const shareTitle = refreshedShareButton.getAttribute('data-share-title') || 'GPS Tracker Quote';
      const shareText = refreshedShareButton.getAttribute('data-share-text') || 'Check out this GPS tracker quote from Pitchero';
      
      console.log("Share button:", refreshedShareButton);
      console.log("Share Title:", shareTitle);
      console.log("Share Text:", shareText);

      const shareData = {
        title: shareTitle,
        text: shareText,
        url: shareUrl,
      };

      if (navigator.share) {
        try {
          console.log("Sharing:", { title: shareTitle, text: shareText, url: shareUrl });
          await navigator.share(shareData);  
          console.log("Shared successfully");
        } catch (err) {
          console.error("Share failed:", err);
          fallbackToClipboard(shareUrl);
        }
      } else {
        fallbackToClipboard(shareUrl);
      }
    });
  }
  
  // Fallback function to copy to clipboard
  function fallbackToClipboard(text) {
    try {
      navigator.clipboard.writeText(text);
      alert("Price estimate link copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy:", err);
      const input = document.createElement('input'); 
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert("Price estimate link copied to clipboard!");
    }
  }

  localStorage.setItem("isSubmitted", JSON.stringify(false));
  let currentStep = 1;
  const form = document.getElementById('multistep-form');
  const steps = document.querySelectorAll('.form-steps');
  const indicators = document.querySelectorAll('.step-indicator');
  const nextBtn = document.querySelector('.btn-next');
  const againBtn = document.querySelector('.btn-agains');
  const submitBtn = document.querySelector('.btn-submit');

  function updateStep(step) { 
    steps.forEach(s => s.classList.remove('active'));
    document.getElementById(`step${step}`).classList.add('active');
    
    indicators.forEach(indicator => {
      const indicatorStep = parseInt(indicator.dataset.step);
      indicator.classList.remove('active', 'completed');
      if (indicatorStep === step) {
        indicator.classList.add('active');
      } else if (indicatorStep < step) {
        indicator.classList.add('completed');
      }
    });

    againBtn.style.display = step === 1 ? 'none' : 'flex';
    nextBtn.style.display = step === 2 ? 'none' : 'block';
  }
  againBtn.addEventListener('click', () => {
    window.scrollTo(0, 0); // Scroll to top before reload
    setTimeout(() => {
      location.reload();
    }, 0);
  });
  function storeSportValue() {
    const sport = document.getElementById('sport-select').value;
    localStorage.setItem('sport', sport);
    calculatePrice(); 
  }

  function getCurrentLanguage() {
    const storedLang = localStorage.getItem('formLanguage');
    if (storedLang) {
      console.log("Using stored language:", storedLang);
      return storedLang;
    }
    
    console.log("Section default language:", sectionDefaultLang);
    return sectionDefaultLang;
  }
  
  function updateFormFieldLabels($form, lang) {
    const translations = {
      en: {
        email: 'Email',
        firstname: 'First Name',
        lastname: 'Last Name',
        phone: 'Phone Number',
        placeholders: {
          email: 'Email',
          firstname: 'First Name',
          lastname: 'Last name'
        }
      },
      es: {
        email: 'Correo Electrónico',
        firstname: 'Nombre',
        lastname: 'Apellido',
        phone: 'Número de Teléfono',
        placeholders: {
          email: 'Correo Electrónico',
          firstname: 'Nombre',
          lastname: 'Apellido'
        }
      },
      fr: {
        email: 'Email',
        firstname: 'Prénom',
        lastname: 'Nom de Famille',
        phone: 'Numéro de Téléphone',
        placeholders: {
          email: 'Email',
          firstname: 'Prénom',
          lastname: 'Nom de famille'
        }
      },
      de: {
        email: 'E-Mail',
        firstname: 'Vorname',
        lastname: 'Nachname',
        phone: 'Telefonnummer',
        placeholders: {
          email: 'E-Mail',
          firstname: 'Vorname',
          lastname: 'Nachname'
        }
      },
      it: {
        email: 'Email',
        firstname: 'Nome',
        lastname: 'Cognome',
        phone: 'Numero di Telefono',
        placeholders: {
          email: 'Email',
          firstname: 'Nome',
          lastname: 'Cognome'
        }
      },
      pt: {
        email: 'Email',
        firstname: 'Nome',
        lastname: 'Sobrenome',
        phone: 'Número de Telefone',
        placeholders: {
          email: 'Email',
          firstname: 'Nome',
          lastname: 'Sobrenome'
        }
      },
      no: {
        email: 'E-post',
        firstname: 'Fornavn',
        lastname: 'Etternavn',
        phone: 'Telefonnummer',
        placeholders: {
          email: 'E-post',
          firstname: 'Fornavn',
          lastname: 'Etternavn'
        }
      },
      sv: {
        email: 'E-post',
        firstname: 'Förnamn',
        lastname: 'Efternamn',
        phone: 'Telefonnummer',
        placeholders: {
          email: 'E-post',
          firstname: 'Förnamn',
          lastname: 'Efternamn'
        }
      },
      da: {
        email: 'E-mail',
        firstname: 'Fornavn',
        lastname: 'Efternavn',
        phone: 'Telefonnummer',
        placeholders: {
          email: 'E-mail',
          firstname: 'Fornavn',
          lastname: 'Efternavn'
        }
      },
      fi: {
        email: 'Sähköposti',
        firstname: 'Etunimi',
        lastname: 'Sukunimi',
        phone: 'Puhelinnumero',
        placeholders: {
          email: 'Sähköposti',
          firstname: 'Etunimi',
          lastname: 'Sukunimi'
        }
      },
      tr: {
        email: 'E-posta',
        firstname: 'Ad',
        lastname: 'Soyadı',
        phone: 'Telefon Numarası',
        placeholders: {
          email: 'E-posta',
          firstname: 'Ad',
          lastname: 'Soyadı'
        }
      }
    };
    
    const langTranslations = translations[lang] || translations.en;
    const formFields = $form.find('.hs-form-field');
    
    if (formFields.length > 0) {
      const firstNameField = $(formFields[0]);
      const label = firstNameField.find('label');
      const input = firstNameField.find('input');
      
      if (label.length) label.text(langTranslations.firstname + '*');
      if (input.length) {
        input.attr('placeholder', langTranslations.placeholders.firstname);
        input.attr('autocomplete', 'off');
        // Clear any pre-filled value
        input.val('');
      }
    }
    
    if (formFields.length > 1) {
      const lastNameField = $(formFields[1]);
      const label = lastNameField.find('label');
      const input = lastNameField.find('input');
      
      if (label.length) label.text(langTranslations.lastname + '*');
      if (input.length) {
        input.attr('placeholder', langTranslations.placeholders.lastname);
        input.attr('autocomplete', 'off');
        // Clear any pre-filled value
        input.val('');
      }
    }
    
    if (formFields.length > 2) {
      const emailField = $(formFields[2]);
      const label = emailField.find('label');
      const input = emailField.find('input');
      
      if (label.length) label.text(langTranslations.email + '*');
      if (input.length) {
        input.attr('placeholder', langTranslations.placeholders.email);
        input.attr('autocomplete', 'off');
        // Clear any pre-filled value
        input.val(''); 
      }
    }
    
    const submitButton = $form.find('input[type="submit"], .hs-button');
    if (submitButton.length) {
      const submitTexts = {
        en: 'VIEW PRICE', es: 'VER PRECIO', fr: 'VOIR LE PRIX', de: 'PREIS ANZEIGEN',
        it: 'VEDI PREZZO', pt: 'VER PREÇO', no: 'SE PRIS', sv: 'SE PRIS',
        da: 'SE PRIS', fi: 'NÄYTÄ HINTA', tr: 'FİYATI GÖR'
      };
      submitButton.val(submitTexts[lang] || submitTexts.en);
    }
    
    console.log("Updated form labels and placeholders for language:", lang);
  }
  
  function getPhoneFieldTranslations(lang) {
    const translations = {
      en: { placeholder: 'Enter phone number', errorMessage: 'Please enter a valid phone number' },
      es: { placeholder: 'Ingrese número de teléfono', errorMessage: 'Por favor ingrese un número de teléfono válido' },
      nz: { placeholder: 'Enter phone number', errorMessage: 'Please enter a valid phone number' },
      fr: { placeholder: 'Entrez le numéro de téléphone', errorMessage: 'Veuillez saisir un numéro de téléphone valide' },
      de: { placeholder: 'Telefonnummer eingeben', errorMessage: 'Bitte geben Sie eine gültige Telefonnummer ein' },
      it: { placeholder: 'Inserisci numero di telefono', errorMessage: 'Si prega di inserire un numero di telefono valido' },
      pt: { placeholder: 'Digite o número de telefone', errorMessage: 'Por favor, insira um número de telefone válido' },
      no: { placeholder: 'Skriv inn telefonnummer', errorMessage: 'Vennligst skriv inn et gyldig telefonnummer' },
      sv: { placeholder: 'Ange telefonnummer', errorMessage: 'Vänligen ange ett giltigt telefonnummer' },
      da: { placeholder: 'Indtast telefonnummer', errorMessage: 'Indtast venligst et gyldigt telefonnummer' },
      fi: { placeholder: 'Syötä puhelinnumero', errorMessage: 'Anna kelvollinen puhelinnumero' },
      tr: { placeholder: 'Telefon numarasını girin', errorMessage: 'Lütfen geçerli bir telefon numarası girin' }
    };
    return translations[lang] || translations.en;
  }

  // Format price with comma separators and round to whole numbers
  function formatPrice(price) {
    const num = Math.round(parseFloat(price));
    return num.toLocaleString('en-US', { 
      minimumFractionDigits: 0,
      maximumFractionDigits: 0 
    });
  }

  function calculatePrice() {
    console.log("Calculating price...");
    const country = document.getElementById('country-select').value;
    const countryCode = document.getElementById('country-select').selectedOptions[0].getAttribute('data-country-code');
    localStorage.setItem('formLanguage', countryCode);
    const quantity = parseInt(document.getElementById('tracker-select').value) || 0;
    const organization_name = document.getElementById('organization_name').value;
    const trackerPrice = document.getElementById('tracker-select').selectedOptions[0].getAttribute('data-year-one-total-price');
    const afterYearOnePriceValue = document.getElementById('tracker-select').selectedOptions[0].getAttribute('data-after-year-one-price');
    const caseValue = document.getElementById('tracker-select').selectedOptions[0].getAttribute('data-case');
    const currentLang = getCurrentLanguage();
    const priceDisplayLabelNumberOfItems1 = document.getElementById('price-display-label-number-of-items-1');
    const priceDisplayLabelNumberOfItems2 = document.getElementById('price-display-label-number-of-items-2');
    const priceDisplayLabelNumberOfItems3 = document.getElementById('price-display-label-number-of-items-3');
    const priceDisplayLabelNumberOfItems4 = document.getElementById('price-display-label-number-of-items-4');
    const { tier_volume, currency, currency_flag, last_currency } = countryPricing[country];
    console.log('tier_volume', tier_volume);
    if(priceDisplayLabelNumberOfItems1) {
        priceDisplayLabelNumberOfItems1.textContent = `x${quantity}`;
    }
    if(priceDisplayLabelNumberOfItems2) {
        priceDisplayLabelNumberOfItems2.textContent = `x${quantity}`;
    }
    if(priceDisplayLabelNumberOfItems3) {
        priceDisplayLabelNumberOfItems3.textContent = `x${caseValue}`;
    }
    // if(priceDisplayLabelNumberOfItems4) {
    //     priceDisplayLabelNumberOfItems4.textContent = `x${quantity}`;
    // }
    let perMonthPrice = 0;
    let afterYearOnePrice = 0;
    if(country && quantity && trackerPrice) {
       console.log('tierVolume', tier_volume);
        console.log('currency_symbol', currency);
        if(tier_volume) {
            perMonthPrice = (quantity * tier_volume) * trackerPrice * 12;
            afterYearOnePrice = (quantity * tier_volume) * afterYearOnePriceValue ;
        } else {
            perMonthPrice = (quantity * trackerPrice) * 12;
            afterYearOnePrice = quantity * afterYearOnePriceValue;
        }

      // Update the DOM elements with calculated values
      const perMonthPriceElement = document.getElementById('per_onth_price');
      const trackerPriceElement = document.getElementById('tracker_price');
      const afterYearOnePriceElement = document.getElementById('after_year_one_price');
      const afterYearOnePriceValueElement = document.getElementById('after_year_one_price_value');
      const countryFlagElement = document.getElementById('country_flag');
      const countryNameElement = document.getElementById('country_name');
      if (perMonthPriceElement) {
        if(last_currency) {
          perMonthPriceElement.textContent =  formatPrice(perMonthPrice) +' '+ last_currency;
        } else {
          perMonthPriceElement.textContent = currency + formatPrice(perMonthPrice);
        }
      }
      if (trackerPriceElement) {
        if(last_currency) {
          if(tier_volume) {
          trackerPriceElement.textContent = formatPrice(trackerPrice * tier_volume) +' '+ last_currency;
          localStorage.setItem('yearOnePerMonthPrice', formatPrice(trackerPrice * tier_volume) +' '+ last_currency);
          } else {
            trackerPriceElement.textContent = formatPrice(trackerPrice) +' '+ last_currency;
            localStorage.setItem('yearOnePerMonthPrice', formatPrice(trackerPrice) +' '+ last_currency);
          }
        } else {
          if(tier_volume) {
            trackerPriceElement.textContent = currency + formatPrice(trackerPrice * tier_volume);
            localStorage.setItem('yearOnePerMonthPrice', currency + formatPrice(trackerPrice * tier_volume));
          } else {
            trackerPriceElement.textContent = currency + formatPrice(trackerPrice);
            localStorage.setItem('yearOnePerMonthPrice', currency + formatPrice(trackerPrice));
          }
        }
      }
      if (afterYearOnePriceElement) {
        if(last_currency) {
       
            afterYearOnePriceElement.textContent = formatPrice(afterYearOnePrice) +' '+ last_currency;
            localStorage.setItem('afterYearOnePerMonthPrice', formatPrice(afterYearOnePrice) +' '+ last_currency);
          
        } else {
       
            afterYearOnePriceElement.textContent = currency + formatPrice(afterYearOnePrice);
            localStorage.setItem('afterYearOnePerMonthPrice', currency + formatPrice(afterYearOnePrice));
        
        }
      }
      if (afterYearOnePriceValueElement) {
        if(last_currency) {
          if(tier_volume) {
            afterYearOnePriceValueElement.textContent = formatPrice(afterYearOnePriceValue * tier_volume) +' '+ last_currency;
            localStorage.setItem('afterYearOnePerMonthPrice', formatPrice(afterYearOnePriceValue * tier_volume) +' '+ last_currency);
          } else {
            afterYearOnePriceValueElement.textContent = formatPrice(afterYearOnePriceValue) +' '+ last_currency;
            localStorage.setItem('afterYearOnePerMonthPrice', formatPrice(afterYearOnePriceValue) +' '+ last_currency);
          }

        } else {
          if(tier_volume) {
            afterYearOnePriceValueElement.textContent = currency + formatPrice(afterYearOnePriceValue * tier_volume);
            localStorage.setItem('afterYearOnePerMonthPrice', currency + formatPrice(afterYearOnePriceValue * tier_volume));
          } else {
            afterYearOnePriceValueElement.textContent = currency + formatPrice(afterYearOnePriceValue);
            localStorage.setItem('afterYearOnePerMonthPrice', currency + formatPrice(afterYearOnePriceValue));
          }
        }
      }
      if (countryFlagElement && currency_flag) {
        countryFlagElement.src = currency_flag;
      }
      if (countryNameElement) {
        countryNameElement.textContent = country;
      }

      // Save to localStorage
      localStorage.setItem('perMonthPrice', currency +''+ perMonthPrice);
      localStorage.setItem('trackerPrice', currency +''+ trackerPrice);
      localStorage.setItem('afterYearOnePriceValue', currency +''+ afterYearOnePriceValue);
      localStorage.setItem('afterYearOnePrice', currency +''+ afterYearOnePrice);
      
    

      console.log('Prices calculated and displayed:', {
        perMonthPrice,
        trackerPrice,
        afterYearOnePrice,
        afterYearOnePriceValue
      });

      // Create HubSpot form
      const formContainer = document.getElementById('hubspot-form-container');
      if (formContainer) {
        // Prevent duplicate form creation
        if (formContainer.querySelector('.hs-form')) {
          console.log("Form already exists, skipping creation");
          return;
        }
        
        formContainer.style.display = 'block';
        formContainer.innerHTML = '';
        console.log("Creating HubSpot form with language:", currentLang);
        
        // Map country codes to HubSpot locale codes
        const countryCodeToLocale = {
          'gb': 'en-gb',
          'au': 'en-au',
          'nz': 'en',
          'za': 'en',
          'us': 'en',
          'ca': 'en',
          'ie': 'en-ie',
          'es': 'es',
          'fr': 'fr',
          'de': 'de',
          'it': 'it',
          'pt': 'pt',
          'no': 'no',
          'se': 'sv',
          'sv': 'sv',
          'dk': 'da',
          'da': 'da',
          'fi': 'fi',
          'tr': 'tr',
          'nl': 'nl',
          'be': 'nl-be',
          'id': 'id',
          'hk': 'zh-hk'
        };
        
        const hubspotLocale = countryCodeToLocale[countryCode.toLowerCase()] || 'en';
        console.log("Using HubSpot locale:", hubspotLocale, "for country code:", countryCode);
        
        if (typeof hbspt !== 'undefined') {
          hbspt.forms.create({
            portalId: "2547723",
            formId: "332ab00b-4604-4327-b178-051cfa796ef8",
            region: "na1",
            locale: hubspotLocale,
            cssRequired: '',
            inlineMessage: 'Thanks for submitting the form.',
            target: "#hubspot-form-container",
            onFormReady: function($form) {
              console.log("HubSpot form ready");
              
              // Find all form fields
              const formFieldsArray = $form.find('.hs-form-field');
              console.log("Form fields found:", formFieldsArray.length);
              
              // Debug: Log all field labels
              formFieldsArray.each(function(index) {
                const label = $(this).find('label').text();
                console.log(`Field ${index}: ${label}`);
              });
              
              // Update form field labels
              updateFormFieldLabels($form, currentLang);
              
              // Create custom phone field after the 4th field (after email field)
              if (formFieldsArray.length >= 4) {
                // Create custom phone field container
                const customFieldContainer = document.createElement('div');
                customFieldContainer.className = 'hs-form-field';
                
                const inputContainer = document.createElement('div');
                inputContainer.className = 'input';
                
                const input = document.createElement('input');
                input.type = 'tel';
                input.className = 'hs-input';
                input.name = 'phone';
                input.id = 'custom_phone_field';
                const phoneTranslations = getPhoneFieldTranslations(currentLang);
                input.placeholder = phoneTranslations.placeholder;
                input.required = true;
                
                // Create error message element
                const errorMessage = document.createElement('div');
                errorMessage.className = 'phone-error-message';
                errorMessage.textContent = phoneTranslations.errorMessage;
                errorMessage.style.color = '#f44336';
                errorMessage.style.fontSize = '12px';
                errorMessage.style.marginTop = '4px';
                errorMessage.style.display = 'none';
                
                inputContainer.appendChild(input);
                inputContainer.appendChild(errorMessage);
                customFieldContainer.appendChild(inputContainer);
                
                // Insert after the 4th field (email field)
                $(formFieldsArray[3]).after(customFieldContainer);
                
                // Initialize intlTelInput after a short delay
                setTimeout(function() {
                  const phoneInput = document.getElementById('custom_phone_field');
                  console.log('Initializing phone input for country:', country);
                  
                  if (phoneInput && window.intlTelInput) {
                    // Map language codes to country codes
                    const languageToCountry = {
                      'en': 'us', 'es': 'es', 'fr': 'fr', 'de': 'de', 'it': 'it', 'pt': 'pt', 'se':'se',
                      'no': 'no', 'sv': 'se', 'da': 'dk', 'fi': 'fi', 'tr': 'tr', 'nz': 'nz', 'dk':'dk',
                      'au': 'au', 'gb': 'gb', 'be': 'be', 'nl':'nl', 'za':'za', 'id':'id', 'hk':'hk'
                    };
                    
                    const initialCountry = languageToCountry[countryCode] || 'us';
                    console.log("Setting phone input country to:", initialCountry, "for language:", currentLang);
                    
                    const iti = window.intlTelInput(phoneInput, {
                      initialCountry: initialCountry,
                      separateDialCode: true,
                      utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.js"
                    });
                    
                    // Disable submit button initially
                    const submitButton = document.querySelector('input.hs-button.primary.large');
                    if (submitButton) {
                      submitButton.disabled = true;
                      submitButton.style.opacity = '0.5';
                      submitButton.style.cursor = 'not-allowed';
                    }
                    
                    // Validate phone on blur
                    phoneInput.addEventListener('blur', function() {
                      console.log('Phone validation:', iti.isValidNumber());
                      
                      const submitButton = document.querySelector('input.hs-button.primary.large');
                      const errorMessage = document.querySelector('.phone-error-message');
                      
                      if (iti.isValidNumber()) {
                        const phoneNumber = iti.getNumber();
                        console.log('Valid phone number:', phoneNumber);
                        
                        // Update hidden HubSpot field
                        let mobilePhoneField = document.getElementById('mobilephone-332ab00b-4604-4327-b178-051cfa796ef8');
                        if (mobilePhoneField) {
                          console.log('Setting value to mobilephone field:', phoneNumber);
                          mobilePhoneField.value = phoneNumber;
                          mobilePhoneField.dispatchEvent(new Event('input', { bubbles: true }));
                          
                          // Enable submit button
                          if (submitButton) {
                            submitButton.disabled = false;
                            submitButton.style.opacity = '1';
                            submitButton.style.cursor = 'pointer';
                          }
                          if (errorMessage) {
                            errorMessage.style.display = 'none';
                          }
                        } else {
                          console.error('Mobile phone field not found');
                        }
                      } else {
                        console.log('Invalid phone number');
                        
                        // Disable submit button and show error
                        if (submitButton) {
                          submitButton.disabled = true;
                          submitButton.style.opacity = '0.5';
                          submitButton.style.cursor = 'not-allowed';
                        }
                        if (errorMessage) {
                          errorMessage.style.display = 'block';
                        }
                      }
                    });
                    
                    // Also validate on input
                    phoneInput.addEventListener('input', function() {
                      const submitButton = document.querySelector('input.hs-button.primary.large');
                      const errorMessage = document.querySelector('.phone-error-message');
                      
                      if (submitButton) {
                        if (iti.isValidNumber()) {
                          submitButton.disabled = false;
                          submitButton.style.opacity = '1';
                          submitButton.style.cursor = 'pointer';
                          if (errorMessage) {
                            errorMessage.style.display = 'none';
                          }
                        } else {
                          submitButton.disabled = true;
                          submitButton.style.opacity = '0.5';
                          submitButton.style.cursor = 'not-allowed';
                          if (errorMessage) {
                            errorMessage.style.display = 'block';
                          }
                        }
                      }
                    });
                  }
                }, 500);
              }
              
              // Populate hidden fields with data from step 1
              const formFields = {
                country: document.getElementById('country-332ab00b-4604-4327-b178-051cfa796ef8'),
                trackers: document.getElementById('number_of_trackers-332ab00b-4604-4327-b178-051cfa796ef8'),
                company: document.getElementById('company-332ab00b-4604-4327-b178-051cfa796ef8'),
                sport: document.getElementById('gps_sport_dropdown-332ab00b-4604-4327-b178-051cfa796ef8'),
                yearOnePrice: document.getElementById('year_one_price-332ab00b-4604-4327-b178-051cfa796ef8'),
                yearOnePerMonthPrice: document.getElementById('year_one__per_trackerper_month-332ab00b-4604-4327-b178-051cfa796ef8'),
                afterYearOnePrice: document.getElementById('after_year_one_price-332ab00b-4604-4327-b178-051cfa796ef8'),
                afterYearOnePerMonthPrice: document.getElementById('after_year_one__per_trackerper_month-332ab00b-4604-4327-b178-051cfa796ef8')
              };
              
              if (formFields.country) {
                formFields.country.value = country;
                formFields.country.dispatchEvent(new Event('input', { bubbles: true }));
              }
              
              if (formFields.trackers) {
                formFields.trackers.value = quantity;
                formFields.trackers.dispatchEvent(new Event('input', { bubbles: true }));
              }
              
              if (formFields.company) {
                formFields.company.value = organization_name;
                formFields.company.dispatchEvent(new Event('input', { bubbles: true }));
              }
              
              const sportData = localStorage.getItem('sport');
              if (formFields.sport && sportData) {
                formFields.sport.value = sportData;
                formFields.sport.dispatchEvent(new Event('input', { bubbles: true }));
              }
              
              // Populate price fields if they exist
              if (formFields.yearOnePrice) {
                let yearOneValue;
                if (last_currency) {
                  yearOneValue = formatPrice(perMonthPrice) + ' ' + last_currency;
                } else {
                  yearOneValue = currency + formatPrice(perMonthPrice);
                }
                formFields.yearOnePrice.value = yearOneValue;
                formFields.yearOnePrice.dispatchEvent(new Event('input', { bubbles: true }));
              }
              
              if (formFields.afterYearOnePrice) {
                let afterYearValue;
                if (last_currency) {
                  afterYearValue = formatPrice(afterYearOnePrice) + ' ' + last_currency;
                } else {
                  afterYearValue = currency + formatPrice(afterYearOnePrice);
                }
                formFields.afterYearOnePrice.value = afterYearValue;
                formFields.afterYearOnePrice.dispatchEvent(new Event('input', { bubbles: true }));
              }

              if (formFields.yearOnePerMonthPrice) {
                let yearOnePerMonthValue = localStorage.getItem('yearOnePerMonthPrice');
                formFields.yearOnePerMonthPrice.value = yearOnePerMonthValue;
                formFields.yearOnePerMonthPrice.dispatchEvent(new Event('input', { bubbles: true }));
              }

              if (formFields.afterYearOnePerMonthPrice) {
                let afterYearOnePerMonthValue = localStorage.getItem('afterYearOnePerMonthPrice');
                formFields.afterYearOnePerMonthPrice.value = afterYearOnePerMonthValue;
                formFields.afterYearOnePerMonthPrice.dispatchEvent(new Event('input', { bubbles: true }));
              }
            }
          });
        } else {
          console.error('HubSpot forms library not loaded');
        }
      } else {
        console.error("Form container not found!");
      }
    }
  }
  
  // Navigation event listeners
  nextBtn.addEventListener('click', () => {
    const sportSelect = document.getElementById('sport-select');
    if (sportSelect && sportSelect.value) {
      localStorage.setItem('sport', sportSelect.value);
    }
    
    if (validateStep(currentStep)) {
      calculatePrice(); // Calculate price before moving to next step
      if (currentStep < 3) {
        currentStep++;
        updateStep(currentStep);
      }
    } else {
      nextBtn.classList.add('shake');
      setTimeout(() => {
        nextBtn.classList.remove('shake');
      }, 500);
    }
  });

  console.log('hubspot-form-container', document.getElementById('hubspot-form-container'));
  
  window.addEventListener('message', event => {
    if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
      $('form').attr('autocomplete', 'off');
    }
  });

  // Price calculation listeners
  document.getElementById('country-select').addEventListener('change', calculatePrice);
  document.getElementById('tracker-select').addEventListener('change', calculatePrice);
  document.getElementById('sport-select').addEventListener('change', storeSportValue);

  // Form validation
  function validateStep(step) {
    const currentStepElement = document.getElementById(`step${step}`);
    const inputs = currentStepElement.querySelectorAll('input[required], select[required]');
    let isValid = true;

    const existingErrors = currentStepElement.querySelectorAll('.error-message');
    existingErrors.forEach(error => error.remove());

    inputs.forEach(input => {
      if (!input.value) {
        isValid = false;
        
        const errorMessage = document.createElement('div');
        errorMessage.className = 'error-message';
        errorMessage.textContent = 'This field is required';
        errorMessage.style.color = '#ff0000';
        errorMessage.style.fontSize = '12px';
        errorMessage.style.marginTop = '5px';
        errorMessage.style.marginBottom = '10px';
        
        input.parentNode.insertBefore(errorMessage, input.nextSibling);
      }
    });

    return isValid;
  }

  const observer = new MutationObserver(() => {
    let submittedMessage = document.querySelector('#hubspot-form-container .submitted-message');
    let priceDisplay = document.querySelector('.price-display');
    let navigationsagain = document.querySelector('.navigationsagain');
    let finalindicator = document.querySelector('.step-indicator:nth-child(3)');
    let shareButton = document.getElementById('shareButton');
    if (submittedMessage) {
      localStorage.setItem("isSubmitted", JSON.stringify(true));
      finalindicator.style.backgroundColor = '#00F0FF';
      priceDisplay.style.display = 'block';
      shareButton.style.display = 'flex';
      navigationsagain.style.display = 'flex';
    } 
    
    const isLoggedIn = JSON.parse(localStorage.getItem("isSubmitted"));
    if (isLoggedIn) {
      navigationsagain.style.display = 'flex';
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Auto-select country if URL contains 'usa' or 'canada'
  const url = window.location.href.toLowerCase();
  const countrySelect = document.getElementById('country-select');
  if (countrySelect) {
    if (url.includes('usa')) {
      for (let i = 0; i < countrySelect.options.length; i++) {
        if (countrySelect.options[i].value.toLowerCase().includes('usa')) {
          countrySelect.selectedIndex = i;
          countrySelect.dispatchEvent(new Event('change'));
          break;
        }
      }
    } else if (url.includes('canada')) {
      for (let i = 0; i < countrySelect.options.length; i++) {
        if (countrySelect.options[i].value.toLowerCase().includes('canada')) {
          countrySelect.selectedIndex = i;
          countrySelect.dispatchEvent(new Event('change'));
          break;
        }
      }
    }
  }
});

